module.exports = __webpack_public_path__ + "img/gq.e4819ce7.png";